import { HiOutlineMail } from "react-icons/hi";
import { RiMessengerLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";

const data = [
  { id: 1, icon: <HiOutlineMail />, link: "mailto: rkeshri522@gmail.com" },
  {
    id: 2,
    icon: <RiMessengerLine />,
    link: "https://www.linkedin.com/in/rahul-keshri-814bb8221/",
  },
  { id: 3, icon: <FaWhatsapp />, link: "https://wa.me/+917631701413" },
];

export default data;
